import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    plase: [],
    plaseDD: [],
    activePlaas: null,
    blokke: [],
    blokkeDD: [],
    blokkePP: [],
    blokkePPDD: [],
    activeBlok: null,
    plaas: {
        loading: true,
        error: {},
        data: null
    },
    blok: {
        loading: true,
        error: {},
        data: null
    },
    eenheidverh: {
        loading: true,
        error: {},
        data: null
    }
};

const setPlase = (state, action) => {
    return updateObject(state, {
        plase: action.plase,
        plaseDD: Object.keys(action.plase).map(key => ({ key, value: action.plase[key].id, text: action.plase[key].naam }))
    });
};

const getPlaseFailed = (state, action) => {
    return updateObject(state, { error: true });
};

const kiesPlaas = (state, action) => {
    // console.log(action.plaas, state.activePlaas);
    if (action.plaas) {
        var plase = [...state.plase];
        for (const plaas of plase) {
            if (plaas.id === action.plaas.value) {
                plaas.aktief = true;
            } else {
                plaas.aktief = false;
            }
        }
        // if (state.activePlaas && action.plaas.value !== state.activePlaas.value) {
        var blokke = [...state.blokke];
        for (const blok of blokke) {
            blok.aktief = false;
        }
        // }
    } else {
        var plase = [...state.plase];
        for (const plaas of plase) {
            plaas.aktief = false;
        }
        var blokke = [...state.blokke];
        for (const blok of blokke) {
            blok.aktief = false;
        }
    }
    return updateObject(state, { activePlaas: action.plaas, activeBlok: null });
};

const setAlleBlokke = (state, action) => {
    return updateObject(state, {
        blokke: action.blokke,
        blokkeDD: action.blokke.length > 0 ? Object.keys(action.blokke).map(key => ({ key, value: action.blokke[key].id, text: action.blokke[key].naam })) : []
    });
};

const getAlleBlokkeFailed = (state, action) => {
    return updateObject(state, { error: true });
};

const setBlokke = (state, action) => {
    return updateObject(state, {
        blokkePP: action.blokke,
        blokkePPDD: action.blokke.length > 0 ? Object.keys(action.blokke).map(key => ({ key, value: action.blokke[key].id, text: action.blokke[key].naam })) : []
    });
};

const getBlokkeFailed = (state, action) => {
    console.log(action);
    return updateObject(state, { error: true });
};

const kiesBlok = (state, action) => {

    // for (const plaas of state.plase) {
    //     plaas.events = {...plaas.events, onMouseMove: (event) => console.log("==> plaas mousemove", event) }
    // }

    if (action.blok) {
        var blokke = [...state.blokke];
        for (const blok of blokke) {
            if (blok.id === action.blok.value) {
                blok.aktief = true;
            } else {
                blok.aktief = false;
            }
        }
    } else {
        var blokke = [...state.blokke];
        for (const blok of blokke) {
            blok.aktief = false;
        }
    }
    return updateObject(state, { activeBlok: action.blok });
};

const initKryPlaas = (state, action) => {
    return updateObject(state, {
        plaas: {...state.plaas, loading: true }
    });
};

const setPlaas = (state, action) => {
    return updateObject(state, { plaas: {...state.plaas, data: action.plaas, loading: false } });
};

const getPlaasFailed = (state, action) => {
    return updateObject(state, { plaas: {...state.plaas, error: { error: action.error, easymessage: action.easymessage, status: action.status, message: action.message }, loading: false } });
};

const initKryBlok = (state, action) => {
    return updateObject(state, {
        blok: {...state.blok, loading: true }
    });
};

const setBlok = (state, action) => {
    return updateObject(state, { blok: {...state.blok, data: action.blok, loading: false } });
};

const getBlokFailed = (state, action) => {
    return updateObject(state, { blok: {...state.blok, error: { error: action.error, easymessage: action.easymessage, status: action.status, message: action.message }, loading: false } });
};

const setEenheidVerhoudings = (state, action) => {
    return updateObject(state, { eenheidverh: {...state.eenheidverh, data: action.data } });
};

const getEenheidVerhoudingsFailed = (state, action) => {
    return updateObject(state, { eenheidverh: {...state.eenheidverh, error: { error: action.error, easymessage: action.easymessage, status: action.status, message: action.message } } });
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RESET_APP:
            return initialState;
        case actionTypes.SET_PLASE:
            return setPlase(state, action);
        case actionTypes.GET_PLASE_FAILED:
            return getPlaseFailed(state, action);
        case actionTypes.KIES_PLAAS:
            return kiesPlaas(state, action);
        case actionTypes.SET_ALLE_BLOKKE:
            return setAlleBlokke(state, action);
        case actionTypes.GET_ALLE_BLOKKE_FAILED:
            return getAlleBlokkeFailed(state, action);
        case actionTypes.SET_BLOKKE:
            return setBlokke(state, action);
        case actionTypes.GET_BLOKKE_FAILED:
            return getBlokkeFailed(state, action);
        case actionTypes.KIES_BLOK:
            return kiesBlok(state, action);
        case actionTypes.INIT_PLAAS:
            return initKryPlaas(state, action);
        case actionTypes.SET_PLAAS:
            return setPlaas(state, action);
        case actionTypes.GET_PLAAS_FAILED:
            return getPlaasFailed(state, action);
        case actionTypes.INIT_BLOK:
            return initKryBlok(state, action);
        case actionTypes.SET_BLOK:
            return setBlok(state, action);
        case actionTypes.GET_BLOK_FAILED:
            return getBlokFailed(state, action);
        case actionTypes.SET_EENHEIDVERH:
            return setEenheidVerhoudings(state, action);
        case actionTypes.GET_EENHEIDVERH_FAILED:
            return getEenheidVerhoudingsFailed(state, action);
        default:
            return state;
    }
};

export default reducer;